<template src="./accept.html"></template>

<script>
import axios from 'axios'
import QuotePreview from '../modals/preview/preview.vue'
import { store } from '../../../store/store'

export default {
  name: 'accept',
  components: {
    QuotePreview
  },
  data: function () {
    return {
      pageState: 'loading',
      errorMessage: '',
      quote: {},
      quoteItems: [],
      contact: {},
      settings: {},
      quoteNumber: '',
      quoteTotal: ''
    }
  },
  methods: {
    loadQuote: function (uuid) {
      this.pageState = 'loading'
      axios.get('public/quote/' + uuid).then((response) => {
        const payload = response.data || {}
        const quote = payload.quote || {}
        const items = Array.isArray(quote.items) ? quote.items : []
        this.quote = Object.assign({}, quote)
        delete this.quote.items
        this.quoteItems = items
        this.contact = quote.contact || {}
        this.settings = payload.settings || {}
        if (quote.status === 'accepted') {
          this.pageState = 'review'
          return
        }
        this.pageState = 'review'
      }).catch((err) => {
        this.errorMessage = (err.response && err.response.data && err.response.data.error)
          ? err.response.data.error
          : 'Quote not found'
        this.pageState = 'error'
      })
    },
    onAccepted: function (payload) {
      this.quoteNumber = payload.number || this.quote.number || ''
      this.quoteTotal = payload.total != null ? payload.total : this.quote.total
      this.pageState = 'success'
    }
  },
  mounted: function () {
    store.commit('setFooter', false)
    this.loadQuote(this.$route.params.uuid)
  },
  beforeUnmount: function () {
    store.commit('setFooter', true)
  }
}
</script>

<style scoped>
.quote-accept-page {
  min-height: calc(100vh - 48px);
  background: var(--color-very-light-grey);
  padding-top: 48px;
  box-sizing: border-box;
}
#app:has(.integration-expired-banner) .quote-accept-page {
  padding-top: 32px;
}
.quote-accept-status {
  max-width: 560px;
  margin: 4rem auto;
  text-align: center;
  padding: 0 1rem;
}
</style>
